import React from "react";
import useReveal from "@/hooks/useReveal";
import { useI18n } from "@/context/LangContext";
import { LockKey, ChartLineUp, Handshake, Clock } from "@phosphor-icons/react";

const VALUES = [
  { icon: Clock, key: "v1" },
  { icon: LockKey, key: "v2" },
  { icon: Handshake, key: "v3" },
  { icon: ChartLineUp, key: "v4" },
];

export default function WhyMaxine() {
  const ref = useReveal();
  const { t } = useI18n();
  return (
    <section id="why" ref={ref} data-testid="why-maxine" className="reveal section border-b border-[color:var(--line)]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4 lg:sticky lg:top-28 self-start">
            <div className="eyebrow">{t("why.eyebrow")}</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02]">
              {t("why.title")}
            </h2>
            <p className="mt-6 text-neutral-700 leading-relaxed">
              {t("why.sub")}
            </p>
          </aside>
          <div className="lg:col-span-8 border-l border-t border-[color:var(--line)]">
            {VALUES.map((v, i) => {
              const Icon = v.icon;
              return (
                <div
                  key={v.key}
                  data-testid={`why-${i}`}
                  className="border-r border-b border-[color:var(--line)] p-8 flex gap-5 items-start hover:bg-neutral-50 transition-colors duration-200"
                >
                  <div className="shrink-0 w-12 h-12 border border-[color:var(--ink)] flex items-center justify-center">
                    <Icon size={22} weight="bold" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-xl">{t(`why.${v.key}.title`)}</h3>
                    <p className="text-neutral-600 mt-2 leading-relaxed">{t(`why.${v.key}.desc`)}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
